<template>
  <div class="padding">
    <div class="mb-3 ske">
      <div>
        <FormCheckbox
          :labelModel.sync="$v.active.$model"
          class="form-checkbox"
          :updateOnClick="true"
          false-label="Inactief"
          true-label="Actief"
          :false-value="false"
          :true-value="true"
          :green="true"
          style="transform: translateX(-10px)"
        >
          Status
        </FormCheckbox>
      </div>
      <!-- <FormCheckbox
        :labelModel.sync="$v.status.$model"

        class="form-checkbox"
        :updateOnClick="true"

        false-label="Onverkrijgbaar"
        true-label="Beschikbaar"
        false-value="DOWN"
        true-value="UP"
      >
        Beschikbaarheid
      </FormCheckbox> -->
    </div>

    <slot></slot>

    <FormInput
      v-model="$v.name.$model"
      :vuelidate="$v"
      fieldName="name"
      :ske="true"
      :focus="true"
      id="name"
      label="Naam winkel"
    />
    <FormInput
      v-model="$v.banner_message.$model"
      :vuelidate="$v"
      fieldName="banner_message"
      :ske="true"
      id="banner_message"
      label="Banner bericht"
    />
    <FormInput
      v-model="$v.seo_meta_title.$model"
      :vuelidate="$v"
      fieldName="seo_meta_title"
      :ske="true"
      id="seo_meta_title"
      label="SEO-title"
    />
    <FormTextarea
      v-model="$v.seo_meta_description.$model"
      :vuelidate="$v"
      fieldName="seo_meta_description"
      :ske="true"
      id="seo_meta_description"
      label="SEO-beschrijving"
    />
    <FormInput
      v-model="$v.customer_support_email.$model"
      :vuelidate="$v"
      fieldName="customer_support_email"
      :ske="true"
      :focus="true"
      id="customer_support_email"
      label="Customer support E-mail"
    />

    <div class="d-xl-flex">
      <FormSelect
        class="form-element"
        v-model="$v.size.$model"
        :ske="true"
        :options="sizeOptions"
        id="size"
        label="Grootte"
      />
      <FormSelect
        class="form-element"
        v-model="$v.language.$model"
        :ske="true"
        :options="languageOptions"
        id="language"
        label="Taal"
      />
    </div>
  </div>
</template>

<script>
import setupForm from "../../mixins/setupForm";
import tableFieldOptions from "../../mixins/tableFieldOptions";

// active: active/inactive; status: Available, Unavailable
// const fields = ["active", "status", "name", "banner_message", "seo_meta_title", "seo_meta_description"]
const fields = [
  "active",
  "name",
  "banner_message",
  "seo_meta_title",
  "seo_meta_description",
  "customer_support_email",
  "size",
  "language"
];

import FormInput from "../Inputs/FormInput.vue";
import FormTextarea from "../Inputs/FormTextarea.vue";
import FormCheckbox from "../Inputs/FormCheckbox.vue";
import FormColorPicker from "../Inputs/FormColorPicker.vue";
import FormSelect from "../Inputs/FormSelect.vue";

import { required, email, alpha, minLength } from "vuelidate/lib/validators";

export default setupForm(
  fields,
  {
    name: "WebsiteDataComponent",
    props: {
      value: Object,
      website_type: String
    },
    mixins: [tableFieldOptions],
    components: {
      FormSelect,
      FormCheckbox,
      FormInput,
      FormTextarea,
      FormColorPicker
    }
  },
  null,
  null,
  function() {
    const physicalStore = this.website_type === "physical_store";
    const getRequiredEnforcementWhenNotPhysical = () => {
      if (physicalStore) return {};
      return { required };
    };
    return {
      // This cannot be removed, see setupForm.js
      ...fields.reduce(
        (form, key) => ({
          ...form,
          [key]: {}
        }),
        {}
      ),
      // ----

      ...fields.reduce(
        (obj, key) => ({
          ...obj,
          // When website is a physical store, it should return an empty object
          [key]: getRequiredEnforcementWhenNotPhysical()
        }),
        {}
      ),
      // THis field needs to be AFTER the ...fields.reduce part, as it woudl overwrite it
      name: {
        // Name should always be verified, so do not use getRequiredEnforcementWhenNotPhysical function
        required,
        alpha
      },
      active: {},
      customer_support_email: {
        // When website is a physical store, it should return an empty object
        ...getRequiredEnforcementWhenNotPhysical(),
        email
      }
      // status: {},
    };
  },
  {
    'name'(val) {
      if (val !== val.toLowerCase()) return val.toLowerCase()
    },
  },
);
</script>

<style scoped src="@/assets/css/form.css"></style>
